import {
    CustomerDetailsPage,
    CustomersCreatePage,
    CustomersMembersCreatePage,
    CustomersMembersPage,
    CustomersPage,
    CustomersStatisticPage,
    CustomersStylesheetPage,
    CustomersInvitesPage,
    CustomersInvitePage,
    CustomerDefaultSpeakersPage,
    GlobalSettings,
} from './views';

const routes = [
    {
        path: '/customers',
        name: 'customers',
        component: CustomersPage,
        meta: {
            title: 'Customers',
        },
    },
    {
        path: '/customers/create',
        name: 'customers-create',
        component: CustomersCreatePage,
        meta: {
            title: 'Create Customers',
        },
    },
    {
        path: '/customers/members',
        name: 'customers-members',
        component: CustomersMembersPage,
        meta: {
            title: 'Team Members',
        },
    },
    {
        path: '/customers/:id',
        name: 'customers-id',
        component: CustomerDetailsPage,
        meta: {
            title: 'Customers',
        },
    },
    {
        path: '/customers/members/create',
        name: 'customers-members-create',
        component: CustomersMembersCreatePage,
        meta: {
            title: 'Create Customers Member',
        },
    },
    {
        path: '/customers/:id/stylesheet',
        name: 'customers-id-stylesheet',
        component: CustomersStylesheetPage,
        meta: {
            title: 'Style sheet',
        },
    },
    {
        path: '/customers/:id/statistic',
        name: 'customers-id-statistic',
        component: CustomersStatisticPage,
        meta: {
            title: 'Statistic',
        },
    },
    {
        path: '/customers/:id/invites',
        name: 'customers-id-invites',
        component: CustomersInvitesPage,
        meta: {
            title: 'Customers invites',
        },
    },
    {
        path: '/customers/:id/default-speakers',
        name: 'customers-id-default-speakers',
        component: CustomerDefaultSpeakersPage,
        meta: {
            title: 'Customers default speakers',
        },
    },
    {
        path: '/invite',
        name: 'invite',
        component: CustomersInvitePage,
        meta: {
            guest: true,
            title: 'Invite',
        },
    },
    {
        path: '/global-settings',
        name: 'global-settings',
        component: GlobalSettings,
        meta: {
            title: 'Global settings',
        },
    },
];

export default routes;
